import { useState } from "react";
import { FaCheck, FaMinus, FaPlus } from "react-icons/fa";
import { Tooltip, IconButton, Popover, Typography, Box } from "@mui/material";
import {
  convertSecondsToHMS,
  convertToUTCString,
} from "../../../../utils/helpers/helper";
import { GoDotFill } from "react-icons/go";

const ZoomMeetingStatus = ({ params }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "zoom-popover" : undefined;

  const meetingDuration = params?.row?.zoomMeetingDuration;

  return (
    <div
      className={`position-relative ${meetingDuration ? "mt-2" : ""}`}
      style={{ display: "inline-block" }}
    >
      {/* Badge Icon - Adjusted Positioning */}
      <div
        className={`badge position-absolute d-flex justify-content-center align-items-center rounded-circle ${
          params?.row?.zoomMeetingStatus === "attended"
            ? "bg-success"
            : "bg-secondary-subtle"
        }`}
        style={{
          width: "15px",
          height: "15px",
          zIndex: "100",
          top: "-2px",
          right:
            meetingDuration > 3600
              ? "0px"
              : meetingDuration > 1800 && meetingDuration <= 3600
              ? "-5px"
              : meetingDuration <= 1800 && meetingDuration >= 50
              ? "-10px"
              : "-15px",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span style={{ fontSize: "10px" }}>
          {params?.row?.zoomMeetingStatus === "attended" ? (
            <FaCheck size={8} />
          ) : params?.row?.zoomMeetingStatus === "not-attended" ? (
            <FaMinus size={8} />
          ) : (
            <GoDotFill size={15} color="orange" />
          )}
        </span>
      </div>

      {/* Tooltip on Hover */}
      <Tooltip
        title={
          params?.row?.zoomMeetingStatus === "attended" || meetingDuration
            ? `Attended Zoom${
                meetingDuration
                  ? ` for ${convertSecondsToHMS(meetingDuration)}`
                  : ""
              }`
            : params?.row?.zoomMeetingStatus === "not-attended"
            ? "Did not attend the Zoom meeting"
            : "Registered for Zoom but did not attend"
        }
        placement="bottom"
      >
        {/* Clickable Icon to Open Popover */}
        <span
          className="input-group-text border-0 bg-transparent p-0 d-flex flex-column "
          onClick={handleClick}
        >
          <img
            src="/assets/img/bsm/zoom-50.png"
            alt="Zoom"
            style={{
              width: "23px",
              height: "23px",
              objectFit: "cover",
            }}
          />
          <small className="" style={{ fontSize: "10px" }}>
            {convertSecondsToHMS(meetingDuration)}
          </small>
        </span>
      </Tooltip>

      {/* Popover for Meeting Details */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300 }}>
          {params?.row?.zoomMeetingDetails &&
          params?.row?.zoomMeetingStatus === "attended" ? (
            <Typography variant="body2">
              <p>
                <strong>Attended Zoom for:</strong>{" "}
                {convertSecondsToHMS(params?.row?.zoomMeetingDetails?.duration)}
                <br />
                <strong>Joined at:</strong>{" "}
                {convertToUTCString(params?.row?.zoomMeetingDetails?.joinTime)}
                <br />
                <strong>Left at:</strong>{" "}
                {convertToUTCString(params?.row?.zoomMeetingDetails?.leaveTime)}
              </p>
            </Typography>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No attendance data available.
            </Typography>
          )}
        </Box>
      </Popover>
    </div>
  );
};

export default ZoomMeetingStatus;
